import { useQuery } from '@tanstack/react-query';

import { MIN_SEARCH_LENGTH } from '@/components/features/UsersList/constants';
import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';

export interface UseDistributorGroupsAutocompleteOptions {
  organizationId: number;
  filter: string;
  enabled?: boolean;
}

export function useDistributorGroupsAutocomplete({ organizationId, filter, enabled = true }: UseDistributorGroupsAutocompleteOptions) {
  const { getAccessToken } = useAuth();

  const isNumeric = /^\d+$/.test(filter);

  return useQuery({
    queryKey: ['distributor-groups-autocomplete', organizationId, filter],
    queryFn: async ({ signal }) => {
      const client = createApiClient(getAccessToken, {
        cache: 'no-store',
        signal,
      });

      const { data, error } = await client.GET('/api/organizations/{organizationId}/distributor-groups/autocomplete', {
        params: {
          path: { organizationId },
          query: { Filter: filter },
        },
      });

      if (error) {
        throw new Error(error.title || 'Failed to fetch distributor groups');
      }

      return data ?? [];
    },
    enabled: enabled && (isNumeric || filter.length >= MIN_SEARCH_LENGTH),
    staleTime: 30000,
  });
}
